import { Customer } from '../customers/Customer';
import { Agency } from '../agency/Agency';
import { ContractPeriodEnum } from './ContractPeriodEnum';
import { ContractStatusEnum } from './ContractStatusEnum';
import { NumberOfTireEnum } from "./NumberOfTireEnum";
import { TireTypeEnum } from './info';
import { TireStoringContractSeasonInfo } from './TireStoringContractSeasonInfo';

export class TireStoringContract {
  public id?: string;
  public slipNo?: string;
  public agency?: Agency = new Agency();
  public customer: Customer = new Customer();
  public signatureImageBase64?: string;
  public signatureImageId?: string;
  public storingDate?: Date;
  public contractEndDate?: Date;
  public pickupDate?: Date;
  public deliveryDate?: Date;
  public period?: ContractPeriodEnum;
  public status: ContractStatusEnum = ContractStatusEnum.DEFAULT;
  public numberOfSummerTire?: NumberOfTireEnum | null;
  public numberOfWinterTire?: NumberOfTireEnum | null;
  public wheelsSize?: string;
  public wheelsBrand?: string;
  public carManufacture?: string;
  public carModel?: string;
  public isExtended?: boolean;
  public extraData?: string;
  public deliveryAgencyId?: string;
  public deliverySaleOfficeId?: string;
  public tireType: TireTypeEnum | null = TireTypeEnum.SUMMER;
  public summerSeasonInfo?: TireStoringContractSeasonInfo = new TireStoringContractSeasonInfo();
  public winterSeasonInfo?: TireStoringContractSeasonInfo = new TireStoringContractSeasonInfo();
  public price?: number = 0;
  public extensionFee?: number = 0;
  public statusChangeDate?: string;
  public note?: string;

  public rackLocation?: string | null = '';
  public columnLocation?: string | null = '';
  public rowLocation?: string | null = '';
  public separateControlNumber?: string | null = '';
  public memo?: string | null = '';
  public number?: string | null = '';
  public storeManager?: string | null = '';

  constructor(init?: Partial<TireStoringContract>) {
    Object.assign(this, init);
  }

}
